import { changeModuleStatus } from '../../../../services/popupApi';

function findSelectedStatusOption(status, dynamicOptions) {
  const expected = String(status ?? '').trim().toLowerCase();
  const options = Array.isArray(dynamicOptions?.status) ? dynamicOptions.status : [];
  return options.find((option) => (
    String(option?.value ?? '').trim().toLowerCase() === expected
    || String(option?.label ?? '').trim().toLowerCase() === expected
    || String(option?._raw?.name ?? '').trim().toLowerCase() === expected
  )) ?? null;
}

export const api = {
  submit: async (values, context, submitPayload) => {
    const selectedOption = findSelectedStatusOption(values.status, submitPayload?.dynamicOptions);
    const raw = selectedOption?._raw ?? {};

    const status = {
      clientSubmissionStatusText: String(raw.name ?? selectedOption?.label ?? values.status ?? '').trim(),
      clientSubmissionStatusId: Number(raw.id ?? raw.uniqueId ?? 0) || 0,
      clientSubmissionStatusType: String(raw.type ?? '').trim(),
    };

    await changeModuleStatus(context.moduleName, context.selectedIds, status);
  },
};
